<div class="page-layout blank fullwidth p-12"  style="height: 1px; overflow-y: scroll; padding: 0 !important;   top: 1px;z-index: 9;">
<div class="container">
  
   
    <!-- <div class="status" [ngClass]="{
      'requested': status === 'Requested',
      'quote-received': status === 'Quote Received',
      'quote-approved': status === 'Quote Approved'

      'order-created': filteredOrderList.length > 0,
      'quote-approved': quotationapproved.length > 0 && filteredOrderList.length === 0,
      'quote-received': quotationreceived.length > 0 && quotationapproved.length === 0 && filteredOrderList.length === 0,
      'requested': quotationreceived.length === 0 && quotationapproved.length === 0 && filteredOrderList.length === 0 
    }">
      {{getStatus()}}
    </div> -->

  <!-- <div class="details" *ngIf="isOpen">
    <div class="logo-and-model">
      <img [src]="getMakeImageUrl(requestDetails?.spareRequest?.make)" alt="Icon" class="img">
      <div class="model-info">
        <span class="model-name">{{requestDetails?.spareRequest?.make}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.model}}, {{requestDetails?.spareRequest?.fuelType}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.registrationNumber}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.vinNumber}}</span>
      </div>
    </div>
    <div class="timestamp">{{requestDetails?.spareRequest?.created | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}
      <button type="button" class="QuoteBtn"  (click)="openSidebarQuote()" *ngIf="activeTab === 'quote-received' && (quotationreceived.length>=0 || quotationapproved.length>0)" >Create Customer Quote</button>
         </div>
    
  </div> -->

  
  <div class="card-container">
  <div class="header">
    <div class="car-info">
      <mat-icon (click)="goBack()" >keyboard_arrow_left</mat-icon>
      <img [src]="getMakeImageUrl(requestDetails?.spareRequest?.make)" alt="Icon" class="img">
      <div>
        <span class="car-name">{{requestDetails?.spareRequest?.model}}</span>
        <span class="car-number">{{requestDetails?.spareRequest?.registrationNumber}}</span>
      </div>
    </div>
    <div>
      <div class="quote-status">
        <div *ngIf="magicQuote==1" style="width: 12%;" class="magic-div"><img class="magic" src="../../../../assets/images/order-details/magic.jpg"></div>

          <div class="status" [ngClass]="{
        'requested': getStatus() === '⏳ Requested',
        'quote-received': getStatus() === '💬 Quote Received',
        'quote-approved': getStatus() === '✅ Quote Approved',
        'order-created': getStatus() === '📦 Order Created',
        'cancelled': getStatus() === '❌ Cancelled'
      }">
        {{getStatus()}}
      </div>
          <button mat-icon-button (click)="toggle()" style="background: linear-gradient(45deg, #F8FAFC, #FFFFFF);border-radius: 11px;margin: 0px;margin-left: 8px;" class="mat-focus-indicator mat-icon-button mat-button-base">
        <mat-icon [ngClass]="{ 'rotated': isOpen }" class="expand_more">expand_more</mat-icon>
      </button>
      </div>
      <button type="button" class="QuoteBtn"  (click)="openSidebarQuote()" *ngIf="activeTab === 'quote-received' && (quotationreceived.length>=0 || quotationapproved.length>0)" >Create Customer Quote</button>
    </div>
  </div>

 <div class="details-grid" *ngIf="isOpen">
  <div class="detail-box">
    <label>VARIANT</label>
    <span>{{requestDetails?.spareRequest?.variant}}</span>
  </div>
  <div class="detail-box">
    <label>REQUEST ID</label>
    <span class="link">#{{requestDetails?.spareRequest?.id}}</span>
  </div>
  <div class="detail-box">
    <label>FUEL & MODEL YEAR</label>
    <span>{{requestDetails?.spareRequest?.fuelType}}, {{requestDetails?.spareRequest?.manufacturingYear}}</span>
  </div>
  <div class="detail-box">
    <label>REQUESTED DATE & TIME</label>
    <span>{{requestDetails?.spareRequest?.created | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}</span>
  </div>

  <!-- Insurance Details -->
  <div class="detail-box full-width" style="background-color: #D7F5FC8C; padding: 10px; border-radius: 6px;" *ngIf="requestDetails?.spareRequest?.claimNo || claimType">
    <h4 class="head-name">🛡️ Insurance Details</h4>
    <div class="insurance">
    <div class="sub-detail">
      <label>Claim Number</label>
      <span>{{requestDetails?.spareRequest?.claimNo}}</span>
    </div>
    <div class="sub-detail">
      <label>Claim Type</label>
      <span>{{requestDetails?.spareRequest?.claimType}}</span>
    </div>
    </div>
  </div>

  <!-- Surveyor Contact -->
  <div class="detail-box full-width" style="background-color: #fff9e6; padding: 10px; border-radius: 6px;" *ngIf="requestDetails?.spareRequest?.surveyor || surveyorContact">
    <h4 class="head-name">🧑‍💼 Surveyor Contact</h4>
    <div class="insurance">
    <div class="sub-detail">
      <label>Surveyor Name</label>
      <span>{{requestDetails?.spareRequest?.surveyor}}</span>
    </div>
    <div class="sub-detail">
      <label>Mobile Number</label>
      <span>📞 {{requestDetails?.spareRequest?.surveyorContact}}</span>
    </div>
    </div>
  </div>
</div>


</div>


  <!-- tabs -->
  <div class="buttons" *ngIf="isRequestDetails">
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'requests'}"
            (click)="setActiveTab('requests')">REQUESTS ({{requestDetails?.spareRequestItemList?.length}}  {{ requestDetails?.spareRequestItemList?.length === 1 ? 'item' : 'items' }})</button>
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'quote-received'}"
            (click)="setActiveTab('quote-received')">QUOTE RECEIVED ({{quotationreceived.length}}  {{ quotationreceived.length === 1 ? 'item' : 'items' }})</button>
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'quote-approved'}"
            (click)="setActiveTab('quote-approved')">QUOTE APPROVED ({{quotationapproved.length}}  {{ quotationapproved.length === 1 ? 'item' : 'items' }})</button>
    <button class="request-button" 
            *ngIf="filteredOrderList?.length>0"
            [ngClass]="{'active': activeTab === 'order-created'}"
            (click)="setActiveTab('order-created')">ORDER CREATED ({{requestDetails?.orderCreatedItems}}  {{ requestDetails?.orderCreatedItems === 1 ? 'item' : 'items' }})</button>
  </div>


  <!-- Request received items -->
  <div *ngIf="isRequestDetails && activeTab === 'requests'" class="request-item">
    <div class="request-info">Request made for {{requestDetails?.spareRequestItemList?.length}} items </div>
    <div class="item-card" *ngFor="let item of requestDetails?.spareRequestItemList">
          <div class="item-header">
            <div class="item-left">
              <p>⚙️</p>
              <div class="item-details">
                <span class="typed-text" *ngIf="!(item.itemDescription==item.itemName)">{{item.itemDescription}}</span>
                <div class="corrected-row">
                  <span class="arrow" *ngIf="!(item.itemDescription==item.itemName)">→
                  <span class="corrected-text">{{item.itemName}}</span>
                </span>
                  <span class="corrected-text" *ngIf="(item.itemDescription==item.itemName)">{{item.itemName}}</span>
                  <span class="tag auto-corrected" *ngIf="!(item.itemDescription==item.itemName)"> ✅ Auto-corrected</span>
                  <span class="tag as-typed" *ngIf="item.itemDescription==item.itemName">⚠️ As Typed</span>
                </div>
                <span class="qty">Qty: {{item.itemQuantity}} Unit</span>
              </div>
            </div>
            <div class="status requested"  *ngIf="item.status==1 || item.status==2 || item.status==3">⏳ Requested</div>
            <div class="status cancelled"  *ngIf="item.status==0">❌ Cancelled</div>
            <div class="status quote-received"  *ngIf="item.status==8">💬 Quote Received</div>
            <div class="status quote-approved"  *ngIf="item.status==9">✅ Quote Approved</div>
            <div class="status order-created"  *ngIf="item.status==4 || item.status==10">📦 Order Created</div>
          </div>
    </div>
  </div>

  <!-- <div *ngIf="isRequestDetails && activeTab === 'requests'" class="request-item">
    <div class="request-info">Request made for {{notes?.length}} items </div>
    <div class="item" *ngFor="let item of notes">
      <span class="span-item-name">{{item}}</span>
      <span class="quantity">1 Unit</span>
    </div>
  </div> -->
  <!-- End Request received items -->

  <!-- Quotation Received -->
  <div *ngIf="activeTab === 'quote-received'">
    <div *ngIf="quotationreceived.length > 0 else noQuotesReceived" class="items" style="    margin-bottom: 78px;">
      <div class="request-info">Quote received for {{quotationreceived.length}} items </div>
      <div class="item" >
        <div class="checkboxselect">
          <label class="custom-checkbox">
            <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
            <span class="checkmark"></span>
          </label>
          
          <div class="select-parts">
          <span >Select All Items</span>
          <p>Choose all parts for approval</p>
          </div>
        </div>
        <div class="select-parts" style="text-align: end;">
          <span class="quote-rcvd-prz">₹ {{quoteReceivedPrice | number:'1.2-2'}}</span>
          <p class="total-slng-prz"> Total MRP Price  </p>
        </div>
      </div>
      <div class="quotereceived-items" *ngFor="let item of quotationreceived" [ngClass]="{'border-box': item.selected}">
        <div style="display: flex;">
          <div class="lines" style="display: flex;">
           <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="item.selected" (change)="toggleItemSelection()" />
            <span class="checkmark"></span>
          </label>

            
          <div style="width: 60%;margin-left: 12px;">
            <span class="part-name" >{{item.itemName}}</span>
            <p class="item-brand">{{item.brand}}</p>
            <p class="item-brand">{{item.itemQuantity}} Unit</p>
          </div>
          </div>
          <div class="lines" style="text-align: end;">
          
            <p class="item-brand">Total MRP</p>
            <span class="date">₹{{(item.mrp * item.itemQuantity) | number:'1.2-2'}}</span>
            <span class="availablity" *ngIf="!isMobile">
             ✅ {{ transform(item.edt) }}
            </span>
          </div>
          </div>
          
          <div *ngIf="isMobile" style="text-align: end;margin-top: -23px;">
          <span class="availablity" *ngIf="isMobile">
             ✅ {{ transform(item.edt)   }}
            </span>
            </div>
        <!-- <div class="lines">  -->
          <!-- Show "Available" -->
<!-- <span class="date-time" style="margin-left: 18px;"
      *ngIf="magicQuote === 1 && item.supplier?.includes('Autoverse Commerce') && !item.spareQuotationId">
  Available
</span> -->

<!-- Show "Checking Availability" -->
<!-- <span class="date-time" style="margin-left: 18px;"
      *ngIf="magicQuote === 1 && !item.supplier?.includes('Autoverse Commerce') && !item.spareQuotationId">
  Checking Availability
</span> -->

<!-- Show Estimated Delivery Date  *ngIf="magicQuote !== 1 || item.spareQuotationId" -->


         
      </div>
    </div>

     <!-- Template for No Quotes Received -->
    <ng-template #noQuotesReceived >
      <div>
        <div class="empty-state">
          <div  *ngIf="isQuoteApproved(); else notApproved">
            <img src="../../../../assets/images/request-details images/requestdetailsimages.png" alt="Quote Approved" class="quote-image">
            <div  class="message">
              <strong >Quote Has Been Approved!</strong>
              <p>Check Quote Approved Section</p>
            </div>
          </div>
        </div>
        <ng-template #notApproved>
          <div class="empty-state"  *ngIf="quotationreceived.length === 0">
            <img src="../../../../assets/images/request-details images/timing.png" alt="Quote Not Created" class="quote-image" style="border-radius: 58px;">
            <div class="message">
              <strong>No quotes received yet</strong>
              <p style="margin-bottom: 0;">Autoverse team is checking availability. We'll</p>
              <p style="margin-top: 0;">notify you as soon as a quote arrives.</p>
            </div>
            <button (click)="goToRequest()">Go to Request</button>
          </div>
        </ng-template>
      </div>
    </ng-template> 
  </div>
  <!-- End Quotation Received -->

  <!-- Content for Quote Approved Tab (under quote approved tab)-->
  <div *ngIf="activeTab === 'quote-approved' && isRequestDetails">
    <div *ngIf="quotationapproved.length > 0; else noQuotesApproved" class="items">
      <div class="request-info" style="display: flex;"> Quote approved for {{quotationapproved.length}} items <button (click)="shareRequestViaWhatsApp()"><i>share</i>Share Approved Quote</button></div>
      <!-- <div class="checkboxselect-approved">
        <input type="checkbox" [checked]="selectAll" (change)="ApprovedtoggleSelectAll()">
        <span style="margin-left: 21px;">Select All</span>
      </div> -->
      <div class="total-selling-price">
        <span>Total MRP Price</span>
        <span class="total-price">₹ {{quoteApprovedPrice | number:'1.2-2'}} </span>
      </div>

      <!-- <hr class="divider"> -->
      <div class="quotereceived-items" *ngFor="let item of quotationapproved" [ngClass]="{'border-box': item.selected}">
           <div style="    display: flex
;">
      <div class="lines" style="display: flex;align-items: center;">        
        <div style="width: 60%;margin-left: 12px;">
            <span class="part-name" >{{item.itemName}}</span>
            <p class="item-brand">{{item.brand}}</p>
            <p class="item-brand">{{item.itemQuantity}} Unit</p>
          </div>
          </div>
          <div class="lines" style="text-align: end;">
          
            <p class="item-brand">Total MRP</p>
            <span class="date">₹{{(item.mrp * item.itemQuantity) | number:'1.2-2'}}</span>
            <span class="availablity" *ngIf="!isMobile">
              ✅ {{ transform(item.edt)  }}
            </span>
          </div>
          </div>
          <div *ngIf="isMobile" style="text-align: end;margin-top: -23px;">
          <span class="availablity" >
             ✅ {{ transform(item.edt)  }}
            </span>
            </div>

    </div>  
    </div>
    <!-- Template for No Quotes Approved -->
    <ng-template #noQuotesApproved>
      <div class="empty-state">
          <div style="font-size: 60px;">📋</div>
           <div class="message">
            <strong>No approved items yet</strong>
            <p>Approve items from the Quote Received tab to see them here.</p>
          </div>
          <button (click)="approveNow()">Go to Quote Received</button>
      </div>
    </ng-template>
  </div>

  <!-- Item Info Sidebar Section -->
  <div class="overlay" [class.visible]="sidebarOpen" (click)="closeSidebar()"></div>
  <div *ngIf='itemDetails' [class.sidebar-open]="sidebarOpen" class="sidebar">
        <div class="sidebar-header" >
          <span class="sidebar-title">{{itemDetails.itemName}}</span>
          <span class="close-btn" (click)="closeSidebar()">&times;</span>
        </div>
        <div class="sidebar-content">
          <div class="sidebar-item">
            <span class="label">Brand</span>
            <span class="value" >{{ itemDetails.brand}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Quantity</span>
            <span class="value">{{itemDetails.itemQuantity}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Availability</span>
            <span class="value">{{itemDetails.edt  | date:'dd MMM yyyy, hh:mm a'}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">MRP(Unit)</span>
            <span class="value">₹{{itemDetails.mrp | number:'1.2-2' }}</span>
          </div>
          <div class="sidebar-item" >
            <span class="label">MRP Total</span>
            <span class="value">₹{{itemDetails.mrp * itemDetails.itemQuantity | number:'1.2-2'}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Selling Price(Unit)</span>
            <span class="value">₹{{itemDetails.mrp - (itemDetails.mrp* itemDetails.sellingDiscount /100) | number:'1.2-2'}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Total Selling Price</span>
            <span class="value">₹{{(itemDetails.mrp - (itemDetails.mrp* itemDetails.sellingDiscount /100)) * itemDetails.itemQuantity | number:'1.2-2' }}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Discount</span>
            <span class="value">{{itemDetails.sellingDiscount}} %</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Part Number</span>
            <span class="value">{{itemDetails.partNumber}}</span>
          </div>
        </div>
        <button class="okay-btn" (click)="closeSidebar()">Okay, got it</button>
  </div>

  <!-- Approve Quote -->
  <div *ngIf="activeTab === 'quote-received' && !jobcardId">

    <div *ngIf="selectAll>0 || selectedItemsCount>0" class="bottom-box">
      <div class="bottom-content">
        <div>
          <div class="total-items">✅ {{selectedItemsCount}} {{ selectedItemsCount === 1 ? 'Part' : 'Parts' }} • {{selectedItemsUnit}} Units • ₹{{totalSelectedPrice | number:'1.2-2'}}</div>

        </div>
      </div>
      <button class="approve-quote-button" (click)="approveQuote()" class="approve-quote-btn">Approve Selected Quote ✨</button>
    </div>
  </div>

  
  <!-- Add to Customer Quote -->
  <div *ngIf="activeTab === 'quote-received' && jobcardId">

    <div *ngIf="selectAll>0 || selectedItemsCount>0" class="bottom-box">
      <div class="bottom-content">
        <div>
          <div class="total-items">{{selectedItemsCount}} items</div>

          <div class="total-amount">Total MRP Price ₹{{totalSelectedPrice | number:'1.2-2'}} </div>
        </div>
      </div>
      <!-- <button class="approve-quote-button" (click)="getAllRequestPopup()">Approve Quote</button> -->
      <button class="approve-quote-button" (click)="addToCustomerQuote()" class="approve-quote-btn">Add To Customer Quote</button>     
    </div>
  </div>
  
  <!-- Order Created -->
  <div *ngIf="activeTab === 'order-created'">
    <div *ngIf="!loading" style="margin-top: 17px;">

                  <div class="order-header" *ngFor="let list of filteredOrderList">
            <div class="header-row">
              <div class="req-num-mag-and-statustag">
                <div class="request-number"> 
                  <svg style ="  width: 36px;    height: 36px;opacity: 1;  top: 196px; left: 333px; border-radius: 12px;    background: linear-gradient(90deg, #E8F2FF 100%, #D7F5FC 0%); padding: 7px;    box-shadow: 0px 1px 0px 0px #FFFFFF;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="req-id-and-claim-type-and-id">
                    <div class="req-id">ORDER ID# {{list.orderNumber}}</div>
                    <div class="only-claim-id-type" >
                      <div class="claim-di"> Request ID# {{list.requestId}}</div>
                    </div>
                  </div>
                </div>
                <div class="header-top-row">
                  <!-- <div class="magic-quote-and-status">
                      <div class="quote-approved-container">
                        <div class="quote-approved" [ngClass]="{
                            'requested': getStatusMessage(list.statusDetails) === 'Requested',
                            'quote-received': getStatusMessage(list.statusDetails) === 'Quote Received',
                            'quote-approved': getStatusMessage(list.statusDetails) === 'Quote Approved',
                            'order-created': getStatusMessage(list.statusDetails) === 'Order Created'
                        }">{{ getStatusMessage(list.statusDetails) }}</div>
                    </div>
                    <div *ngIf="list.magicQuote==1" class="its-magic-class" > ✨ It's Magic</div>
                  </div> -->
                  <div class="magic-quote-and-status" [ngClass]="{'no-magic': magicQuote != 1}">
                    <div class="quote-approved-container">
                      <!-- <div class="quote-approved" [ngClass]="{
                          'requested': list.orderCurrentStatus === 'Delivered',
                          'quote-received': list.orderCurrentStatus === 'Confirmed',
                          'quote-approved': list.orderCurrentStatus === 'Packed',
                          'order-created': list.orderCurrentStatus==='On The Way'
                      }">
                        {{ list.orderCurrentStatus }}
                      </div> -->
  <div  *ngIf="list.packageDetails.length <= 0">
                      <div class="status requested"  *ngIf="list.orderCurrentStatus === 'Packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="list.orderCurrentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="list.orderCurrentStatus === 'Confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="list.orderCurrentStatus === 'Delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="list.orderCurrentStatus === 'created'">🆕 Created</div>
                    </div>
                       <div  *ngIf="list.packageDetails.length == 1 && list.notPackedItems.length <= 0">
                        <div *ngFor="let delivery of list.packageDetails; let i = index">
                        <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                       </div>
                      </div>
                    </div>

                    <div *ngIf="magicQuote == 1" class="its-magic-class">✨ It's Magic</div>
                  </div>

                </div>
              </div>
                <!-- <div *ngIf="list.magicQuote==1" ><img class="magic" src="../../../../assets/images/order-details/magic.jpg"></div> -->

        </div>

            <!-- <div class="header-row1">
                <div class="num-of-item-with-clain-id-type" >
                  <div style="display: inline; width: 90%;">
                    <div class="items-rqstd-cls">Items Requested</div>
                      <div class="no-of-items" >
                        <span *ngFor="let items of list.orderItems; index as i">
                          <span *ngIf="i!=0">,</span> {{items.partName}}</span></div>
                  </div>
                  
                <div style="width: 10%;text-align: end;">
                      <div class="total-amount-text">Total  Amount</div>
                      <div class="total-amount-price" >₹ {{list.grandTotal + list.shippingCharges}}</div>
                </div>
                </div>
            </div> -->
            <div  *ngIf ="list.packageDetails.length <= 1 && list.notPackedItems.length <= 0" class="delivery-content">
                <div  class="request-ids">
                  <div class="header-row1">
                    <div class="order-item">
                      <div class="items-rqstd-cls">Items Requested</div>
                      <span *ngFor="let item of list.orderItems; let idx = index" class="item-name">
                        <span *ngIf="idx != 0">,</span> {{ item.partName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div  *ngIf ="list.packageDetails.length <= 0 && list.notPackedItems.length >= 0" class="delivery-content">
                <div  class="request-ids">
                  <div class="header-row1">
                    <div class="order-item">
                      <div class="items-rqstd-cls">Items Requested</div>
                      <span *ngFor="let item of list.orderItems; let idx = index" class="item-name">
                        <span *ngIf="idx != 0">,</span> {{ item.partName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="list.packageDetails.length > 1">
                <div *ngFor="let delivery of list.packageDetails; let i = index" class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">Delivery {{ i + 1 }}</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                    
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                              <div class="items-rqstd-cls">Items Requested</div>
                                <span *ngFor="let item of delivery.items; let idx = index" class="item-name">
                                  <span *ngIf="idx != 0">,</span> {{ item.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                          
                        <div class="order-status" *ngIf=" delivery.shipmentStatus === 'delivered'">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
                <!-- ✅ Show Not Packed Items for each order -->
                 <div *ngIf="list.notPackedItems.length > 0">
                   <div  class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">To Be Delivered</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status quote-approved" >
                         ✅ Confirmed 
                         <!-- <mat-icon  class="check-circle-mat-icon confirmed-status">thumb_up</mat-icon> -->
                        </div>
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                               <div class="items-rqstd-cls">Items Requested</div>
                                <span *ngFor="let item of list.notPackedItems; let idx = index" class="item-name">
                                  <span *ngIf="idx != 0">,</span> {{ item.partName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
                </div>
                </div>

              </div>
              <div *ngIf="list.packageDetails.length == 1 && list.notPackedItems.length > 0">
                <div *ngFor="let delivery of list.packageDetails; let i = index" class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">Delivery {{ i + 1 }}</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                       <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                    
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                                <span *ngFor="let item of delivery.items; let idx = index">
                                  <span *ngIf="idx != 0">,</span> {{ item.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                          
                        <div class="order-status" *ngIf=" delivery.shipmentStatus === 'delivered'">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
                <!-- ✅ Show Not Packed Items for each order -->
                 <div *ngIf="list.notPackedItems.length > 0">
                   <div  class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">To Be Delivered</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status quote-approved" >
                         ✅ Confirmed 
                            <!-- <mat-icon  class="check-circle-mat-icon confirmed-status">thumb_up</mat-icon> -->
                        </div>
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                                <span *ngFor="let item of list.notPackedItems; let idx = index">
                                  <span *ngIf="idx != 0">,</span> {{ item.partName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
                </div>
                </div>

              </div>
            <div class="header-row2">
              <div class="request-date">Placed on: {{list.createdAt | date:'dd MMM yyyy, hh:mm a'}}</div>
              <a class="view-btn" (click)="loadorderdetails(list.orderKey)" >
                <mat-icon style="color: white; margin-right: 0px;">keyboard_arrow_right</mat-icon>
                <div class="view">View Details</div>
              </a>
            </div>
          </div>
      </div>
  </div>

</div>

</div>
<div #dynamicContainer></div>

<!-- Edit Item -->
<div class="overlay1" [class.visible]="isPopupOpenEdit" (click)="closePopupEdit()"></div>
<div *ngIf="isPopupOpenEdit" [ngClass]="isMobile ? 'bottom-sheetMobile' : 'bottom-sheet'">
  <header class="back-button">
    <h3 class="header-name">{{ itemQuote.itemName }}</h3>
    <mat-icon (click)="closePopupEdit()" class="close-pop-up">close</mat-icon>
  </header>
  <div class="bottom-sheet-content">
    <form [formGroup]="unitPrice" >
    <div class="unit-price">
      <mat-form-field appearance="outline" class="full-width" class="edit-labour-details">
        <mat-label>Unit Price</mat-label>
        <input
          matInput
          formControlName="unitprice"                            
          [(ngModel)]="itemQuote.mrp"
          placeholder="Enter Unit Price*"
          required
          name="Unit Price"
          pattern="^[0-9]*$"
        />
        </mat-form-field>
    </div>
  </form>
    <button (click)="save()">Save Quote</button>
  </div>
</div>
<!-- End Edit Item -->


<!-- Popup content -->
<div *ngIf="isQuotationPopup" class="add-items-to-quotation popup">
  <div class="popup-content">
    <mat-icon (click)="closeQuotationPopup()" style="float: right; cursor: pointer;">close</mat-icon>
    <h3>Quotation Confirmation</h3>
        
    <p class="order-label">Customer Quotation Already Exists.</p>
    
    <p class="">Would you like to edit the customer quotation?</p>

    <button class="quote-yes" (click)="editQuotationItems()">Yes</button>
    <button class="quote-no" (click)="closeQuotationPopup()">No</button>
  </div>
</div>


<div #createQuotationContainer></div>